import { BadgeCheck, GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import { useSiteConfig } from "./SiteLayout";

export function AuthorBadge({ compact = false, date }) {
  const cfg = useSiteConfig();
  const name = [cfg.author_name || "Vincenzo", cfg.author_surname].filter(Boolean).join(" ");
  const initials = name.split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase();
  return (
    <div className={`flex items-center gap-3 ${compact ? "" : "surface p-5"}`} data-testid="author-eat-badge">
      {cfg.author_photo ? (
        <img src={cfg.author_photo} alt={name} className={`${compact ? "h-10 w-10" : "h-14 w-14"} rounded-full object-cover ring-2 ring-emerald-500/40`} />
      ) : (
        <span className={`${compact ? "h-10 w-10 text-sm" : "h-14 w-14 text-lg"} grid place-items-center rounded-full bg-emerald-500/15 text-emerald-500 font-display font-bold ring-2 ring-emerald-500/40`}>{initials}</span>
      )}
      <div className="min-w-0">
        <div className="flex items-center gap-1.5 flex-wrap">
          <Link to="/chi-siamo" className="font-display font-semibold hover:text-emerald-500" data-testid="author-name">{name}</Link>
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500/10 text-emerald-500 px-2 py-0.5 text-[11px] font-medium"><BadgeCheck size={12} /> Autore verificato</span>
        </div>
        <p className="text-xs text-muted-foreground flex items-center gap-1.5 mt-0.5">
          <GraduationCap size={12} /> Fondatore Polizzapet.it · Formazione IVASS in corso{date ? ` · ${date}` : ""}
        </p>
        {!compact && <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{cfg.author_bio}</p>}
      </div>
    </div>
  );
}
